import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHeader, Reveal } from "@/components/bits";
import { SERVICES } from "@/data/site";

const Services = () => (
  <>
    <Seo
      title="Services | Ambrotech Private Limited"
      description="Solar product supply, site survey and system planning, and solar installation and project support — arranged according to project requirements and the agreed scope."
      path="/services"
    />

    <PageHeader
      eyebrow="Services"
      title="Supply, planning, and installation support"
      lead="Products and components are supplied according to project requirements and availability. Installation support is arranged according to the agreed scope."
    />

    <section className="mx-auto max-w-7xl space-y-16 px-5 py-16 sm:px-8 lg:space-y-24 lg:py-24">
      {SERVICES.map((s, i) => (
        <Reveal key={s.id}>
          <div
            className={`grid items-center gap-10 lg:grid-cols-2 lg:gap-16 ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}
            data-testid={`service-section-${s.id}`}
          >
            <div className="relative">
              <div aria-hidden="true" className={`absolute hidden h-full w-full rounded-2xl border border-brand/50 sm:block ${i % 2 === 1 ? "-right-3 -top-3" : "-left-3 -top-3"}`} />
              <img
                src={s.image}
                alt={s.alt}
                loading="lazy"
                className="relative h-[280px] w-full rounded-2xl object-cover shadow-[0_20px_50px_rgba(11,25,44,0.14)] sm:h-[360px]"
              />
            </div>
            <div>
              <span className="font-display text-5xl font-bold text-slate-100">0{i + 1}</span>
              <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl">
                {s.title}
              </h2>
              <p className="mt-4 max-w-lg text-base leading-relaxed text-slate-600">{s.description}</p>
              <Link
                to="/contact"
                state={{ product: s.title }}
                data-testid={`service-enquire-${s.id}`}
                className="group mt-6 inline-flex items-center gap-2 rounded-full border border-slate-300 px-6 py-3 text-sm font-semibold text-navy transition-colors hover:border-brand hover:text-brand"
              >
                Enquire About This Service
                <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
              </Link>
            </div>
          </div>
        </Reveal>
      ))}
    </section>

    <section className="bg-navy py-16 lg:py-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="flex flex-wrap items-center justify-between gap-6">
            <div className="max-w-2xl">
              <h2 className="font-display text-2xl font-bold text-white sm:text-3xl">
                Share your project details
              </h2>
              <p className="mt-2 text-sm text-slate-300 sm:text-base">
                We will confirm scope, availability, and the support we can provide.
              </p>
            </div>
            <Link
              to="/contact"
              data-testid="services-contact-cta"
              className="group inline-flex items-center gap-2 rounded-full bg-brand px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-brand-hover"
            >
              Contact Us
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default Services;